/**
 * @generated SignedSource<<57181824732afbcdd4a3df849128e58e>>
 * @relayHash edce962ea01b27c47f0089fbb88a6b27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cb6398ffef72c10a36e4e3606e1bced0e774396aac1654be17644dae3c1d5148

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedParentQuery } from './decomposedParentQuery.graphql';

const node: PreloadableConcreteRequest<decomposedParentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cb6398ffef72c10a36e4e3606e1bced0e774396aac1654be17644dae3c1d5148",
    "metadata": {},
    "name": "decomposedParentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
